import React, { useState } from 'react'
import MainLayout from '../../../../layouts/main/main_layout';
import { Box, Button, Card, CardContent, Grid, IconButton, ListItem, ListItemText, Typography } from '@mui/material';
import { ArrowBack, ArrowBackRounded, PersonRounded } from '@mui/icons-material';
import Loading from '../../../../components/loading/loading';
import { useNavigate, useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import { deleteClient, getIndividualClientDetails } from '../../../../services/client_mapping/client_mapping';
import { ClientDetail } from '../../model/client_details';
import RevokeAccess from '../revoke_access/revoke_access';
import { useFeedback } from '../../../../providers/feedback/feeedback';
import { queryClient } from '../../../../providers/query/query';
import { greyEnabled, purple, purpleLight, black } from '../../../../theme/colors';
import { client_mapping } from '../../../../routes/routes_path';


export default function ClientDetails() {
    const [deleteAdmin, setDeleteAdmin] = useState(false);
    const [revokeSubmitting, setRevokeSubmitting] = useState(false);
    const { id } = useParams()
    const navigate = useNavigate();
    const { showSnackbar } = useFeedback();

    const { data: details, isLoading } = useQuery<ClientDetail>(
        ["individual-Client-Details", id],
        async () => {
            let { data } = await getIndividualClientDetails({ id: +id! });
            return data?.data;
        }
    );


    const deleteAdminApiCall = () => {
        setRevokeSubmitting(true);
        deleteClient({ clientId: +id! })
            .then((res) => {
                setDeleteAdmin(false);
                showSnackbar(res?.data?.data?.message || "");
                queryClient.invalidateQueries({ queryKey: ["client-List"] });
                navigate(client_mapping)
            })
            .catch((e) => {
                setDeleteAdmin(false);
                showSnackbar("Something Went wrong");
            })
            .finally(() => setRevokeSubmitting(false));
    };

    function listItem({
        title,
        value,
    }: {
        title: string;
        value: any;
    }): JSX.Element {
        return (
            <Box style={{
                overflow: "hidden",
            }}>
                <Typography
                    variant="body2"
                    sx={{ color: greyEnabled, fontWeight: 600, letterSpacing: 0.2 }}
                >
                    {title}
                </Typography>
                <Typography
                    sx={{ color: black, fontWeight: 500, mt: 0.25 }}
                    textOverflow={"ellipsis"}
                    overflow="hidden"
                >
                    {value || "-"}
                </Typography>
            </Box>
        );
    }
    return (
        <MainLayout>
            <Box>
                <Box display="flex" alignItems="center" gap={1}>
                    <IconButton onClick={() => navigate(-1)}>
                        <ArrowBackRounded />
                    </IconButton>
                    <Box display="flex" alignItems="center" gap={1.5}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: 40,
                                height: 40,
                                borderRadius: 2,
                                bgcolor: purpleLight,
                                flexShrink: 0,
                            }}
                        >
                            <PersonRounded sx={{ color: purple, fontSize: 22 }} />
                        </Box>
                        <Box>
                            <Typography variant="h5" fontWeight={700} color={black}>
                                Client Details
                            </Typography>
                            <Typography variant="body2" color={greyEnabled}>
                                {details?.clientName || "View client mapping details."}
                            </Typography>
                        </Box>
                    </Box>
                </Box>

                <Card
                    elevation={0}
                    sx={{ width: '100%', mt: 2, borderRadius: 3, border: '1px solid #ECECEC' }}
                >
                    <CardContent sx={{ p: { xs: 2.5, sm: 4 } }}>
                            <Box m={0}>
                                {isLoading ? (
                                    <Box display="flex" justifyContent="center" py={8}>
                                        <Loading />
                                    </Box>
                                ) : (
                                    <Box overflow="auto" flex={1}>
                                        <Grid container spacing={3}>
                                            <Grid item md={6} sm={12}>
                                                {listItem({
                                                    title: "Client Name",
                                                    value: details?.clientName,
                                                })}
                                            </Grid>
                                            <Grid item md={6} sm={12}>
                                                {listItem({
                                                    title: "Email Id",
                                                    value: details?.emailId,
                                                })}
                                            </Grid>
                                            <Grid item md={6} sm={12}>
                                                <Box>
                                                    <Typography
                                                        variant="body2"
                                                        sx={{ color: greyEnabled, fontWeight: 600, letterSpacing: 0.2 }}
                                                    >
                                                        Module
                                                    </Typography>
                                                    {details?.module?.map((i: string) =>
                                                        <Typography key={i} sx={{ color: black, fontWeight: 500, mt: 0.25 }}>{i || "-"}</Typography>
                                                    )}
                                                </Box>
                                            </Grid>

                                            <Grid item md={6} sm={12}>
                                                {listItem({
                                                    title: "Role Assigned",
                                                    value: details?.roleAssigned,
                                                })}
                                            </Grid>
                                            {/* <Grid item md={6} sm={12}>
                                                {listItem({
                                                    title: "Type",
                                                    value: '-',
                                                })}
                                            </Grid> */}
                                            {details?.module.includes('needs') &&
                                                <>
                                                    <Grid item md={6} sm={12}>
                                                        {listItem({
                                                            title: "Category",
                                                            value: details?.category?.name,
                                                        })}
                                                    </Grid>
                                                    <Grid item md={6} sm={12}>
                                                        {listItem({
                                                            title: "State",
                                                            value: details?.state?.name,
                                                        })}
                                                    </Grid>
                                                    <Grid item md={6} sm={12}>
                                                        <Box>
                                                            <Typography
                                                                variant="body2"
                                                                sx={{ color: greyEnabled, fontWeight: 600, letterSpacing: 0.2 }}
                                                            >
                                                                Area
                                                            </Typography>
                                                            {details?.area?.map((i: { id: number, name: string }) =>
                                                                <Typography key={i.id} sx={{ color: black, fontWeight: 500, mt: 0.25 }}>{i?.name || "-"}</Typography>
                                                            )}
                                                        </Box>
                                                    </Grid>
                                                    <Grid item md={6} sm={12}>
                                                        <Box>
                                                            <Typography
                                                                variant="body2"
                                                                sx={{ color: greyEnabled, fontWeight: 600, letterSpacing: 0.2 }}
                                                            >
                                                                City
                                                            </Typography>
                                                            {details?.city?.map((i: { id: number, name: string }) =>
                                                                <Typography key={i.id} sx={{ color: black, fontWeight: 500, mt: 0.25 }}>{i.name || "-"}</Typography>
                                                            )}
                                                        </Box>
                                                    </Grid></>}
                                            {details?.module.includes('schemes') &&
                                                <Grid item md={12} sm={12}>
                                                    <Typography
                                                        variant="body2"
                                                        sx={{ color: greyEnabled, fontWeight: 600, letterSpacing: 0.2 }}
                                                    >
                                                        Schemes
                                                    </Typography>
                                                    {details?.schemeDetails?.map((item) => {
                                                        return <>
                                                            <ListItem
                                                                sx={{
                                                                    margin: 0,
                                                                    padding: 0,
                                                                }}
                                                            >
                                                                <ListItemText
                                                                    primary={item?.name}
                                                                    secondary={
                                                                        <Box display="flex" flexDirection="row">
                                                                            <Typography variant="body2">{item.schemeGovernmentType}</Typography>
                                                                            <Box display={"flex"} flexDirection={'row'} mb={1}>
                                                                                <Typography
                                                                                    color="primary.main"
                                                                                    variant="body2"
                                                                                    textTransform={"capitalize"}
                                                                                    ml={1}
                                                                                    mr={1}
                                                                                >
                                                                                    {item?.schemeCategory}
                                                                                </Typography>
                                                                            </Box>
                                                                        </Box>
                                                                    }
                                                                    primaryTypographyProps={{
                                                                        color: black,
                                                                        fontWeight: 600
                                                                    }}
                                                                    secondaryTypographyProps={{
                                                                        color: "#91278F",
                                                                    }}
                                                                />
                                                            </ListItem>
                                                        </>
                                                    })}
                                                </Grid>}
                                        </Grid>
                                    </Box>
                                )}

                            </Box>

                            <Box display="flex" justifyContent="space-between" flexWrap="wrap" gap={1.5} mt={4}>
                                <Button
                                    variant="outlined"
                                    startIcon={<ArrowBackRounded sx={{ height: 18, width: 18 }} />}
                                    sx={{
                                        borderColor: purple,
                                        color: purple,
                                        borderRadius: 2,
                                        textTransform: "none",
                                        fontWeight: 600,
                                        "&:hover": { borderColor: purple, bgcolor: purpleLight },
                                    }}
                                    onClick={() => navigate(-1)}
                                >
                                    Back To Client Mapping
                                </Button>
                                <Button
                                    variant="outlined"
                                    sx={{
                                        minWidth: 150,
                                        borderColor: purple,
                                        color: purple,
                                        borderRadius: 2,
                                        textTransform: "none",
                                        fontWeight: 600,
                                        "&:hover": { borderColor: purple, bgcolor: purpleLight },
                                    }}
                                    onClick={() => setDeleteAdmin(true)}
                                >
                                    Revoke Access
                                </Button>
                            </Box>
                        </CardContent>
                    </Card>
                </Box>
            <RevokeAccess
                deleteAdminApiCall={deleteAdminApiCall}
                open={deleteAdmin}
                setDeleteAdmin={setDeleteAdmin}
                submitting={revokeSubmitting}
            />
        </MainLayout >
    )
}
